/**
 * Schema of SAC
 * @author ftgibran
 */
import {datetime, Schema} from 'simpli-web-sdk'
import RenderNumber from '@/components/render/RenderNumber.vue'
import SacResponse from '@/model/response/SacResponse'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: SacResponse): Schema => ({
  attempt: {
    content: {
      component: RenderNumber,
      props: {
        number: model.attempt || 0,
      },
    },
  },

  status: {
    content: {
      component: RenderLabelValue,
      props: {
        value: model.status,
        tagClass: model.statusTagClass,
      },
    },
  },

  event: {
    content: {
      component: RenderLabelValue,
      props: {
        value: model.event,
        tagClass: `basic ${model.statusTagClass}`,
      },
    },
  },

  date: {
    content: datetime(model.date),
  },

  shipperName: {
    content: model.shipperName,
  },
})
